import axios from "axios";
import type { AxiosRequestConfig } from "axios";

import { API_BASE_URL } from "@shared/config";
import { createResponseInterceptor } from "./interceptors/responseInterceptor";
import {
  unauthorizedHandler,
  legalDocumentHandler,
  backendErrorParserHandler,
} from "./interceptors/errorHandlers";

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
});

axiosClient.defaults.withCredentials = true;

const errorHandlers = [
  unauthorizedHandler,
  legalDocumentHandler,
  backendErrorParserHandler,
];

const { onFulfilled, onRejected } = createResponseInterceptor(errorHandlers);

axiosClient.interceptors.response.use(onFulfilled, onRejected);

export const axiosGetData = async <T>(
  endpoint: string,
  params?: Record<string, unknown>,
): Promise<T> => {
  const { data } = await axiosClient.get<T>(endpoint, { params });

  return data;
};

export const axiosPostData = async <T, B = object>(
  endpoint: string,
  body?: B,
  config?: AxiosRequestConfig,
): Promise<T> => {
  const { data } = await axiosClient.post<T>(endpoint, body, config);

  return data;
};

export const axiosPatchData = async <T, B>(
  endpoint: string,
  body: B,
): Promise<T> => {
  const { data } = await axiosClient.patch<T>(endpoint, body);

  return data;
};

export const axiosDeleteData = async <T, B = object>(
  endpoint: string,
  body?: B,
): Promise<T> => {
  const { data } = await axiosClient.delete<T>(endpoint, { data: body });

  return data;
};

export const axiosPutData = async <T, B>(
  endpoint: string,
  body: B,
): Promise<T> => {
  const { data } = await axiosClient.put<T>(endpoint, body);

  return data;
};

export default axiosClient;
